import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
    HttpInterceptor
} from '@angular/common/http';
import { Router } from "@angular/router";
import { map, tap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from "rxjs";
import { NotificationService } from '../shared/toastrservice.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        public router: Router,
        private spinner: NgxSpinnerService,
        private toastr : NotificationService
    ) {

    }
    intercept(
        req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.spinner.show();
        if (localStorage.getItem('loginData')) {
            let loginData = JSON.parse(localStorage.getItem('loginData'));
            req = req.clone({
                setHeaders: {
                    Authorization: "Token " + loginData.token
                    //Authorization: "Token " + "0efbcb80917ac2944471c5f5605d9efdbfd56d70"
                }
            });
        }

        return next.handle(req).pipe(tap(
            (event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.spinner.hide();
                }
            },
            (err: any) => {
                console.log("err.error.status", err.error);
                if (err.error.status_code == 401) {
                    this.spinner.hide();
                    localStorage.removeItem('loginData');
                    localStorage.removeItem('permissions');
                    this.router.navigate(['/login']);
                    this.toastr.clean();
                    this.toastr.showError("Your session has expired. Please relogin", "Error");
                }
                if (err instanceof HttpErrorResponse) {
                    this.spinner.hide();
                }
            }
        ));
    }

}
